import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { SubscriptionsListControllerModule } from './controllers/SubscriptionsListController';

export const SubscriptionsListView = angular
  .module('acme.view.application.subscriptions.list', [uiRouter, 'ui.bootstrap', SubscriptionsListControllerModule])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const subscriptionsList = {
      name: 'application.subscriptions.list',
      url: '/list',
      views: {
        'subview-main': {
          controller: 'SubscriptionsListController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/subscriptions/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Subscriptions List',
        /** Secure With Permissions **/
        permissions: ['SUBSCRIPTION_VIEW'],
        enablePreferences: true,
      },
    };

    $stateProvider.state(subscriptionsList);
  }).name;
